export default "__VITE_ASSET__Ck$4ljkw__"